import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATION, GLOBAL_CONSTANTS, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { nullUndefinedEmptyCheck, validateInput } from '../../utils/helper';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { headerBreadcam } from '../../service/apiSlices/staticReducer';
import { useDispatch } from 'react-redux';
import { useLoginMutation } from '../../service/apiSlices/authService';
import { toast } from 'react-toastify';
import { Avatar } from '@mui/material';
import Logo from "../../assets/logo.svg";
import LeftSidContainer from './leftSidePart';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="/">
                {GLOBAL_CONSTANTS.MAINTITLE}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function Login() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [Visibility, setVisibility] = useState('password')
    const [rememberMe, setRememberMe] = useState(false);
    const [loginInfo, setLoginInfo] = useState({
        email: '',
        password: ''
    });
    const [error, setError] = useState<any>({
        email: '',
        password: ''
    })
    const [errorMsg, setErrorMsg] = useState({
        email: '',
        password: ''
    })

    const [loginApiCall] = useLoginMutation()
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // Perform login logic here
        if (rememberMe) {
            localStorage.setItem(AUTHENTICATION?.SHARED.REMEMBERME_EMAIL, loginInfo?.email);
            localStorage.setItem(AUTHENTICATION?.SHARED.REMEMBERME_PASDWORD, loginInfo?.password);
        } else {
            localStorage.removeItem(AUTHENTICATION.SHARED.REMEMBERME_EMAIL);
            localStorage.removeItem(AUTHENTICATION.SHARED.REMEMBERME_PASDWORD);
        }
        if (nullUndefinedEmptyCheck(loginInfo.email) && nullUndefinedEmptyCheck(loginInfo.password)
            && !error.email && !error.password) {
            const data = new FormData(event.currentTarget);
            var payload = {
                email: data.get('email') ?? loginInfo.email,
                password: data.get('password') ?? loginInfo.password,
            }
            loginApiCall(payload)
                .unwrap()
                .then((response) => {
                    var getData = response?.result?.data;

                    toast.success(response?.message, TOASTER_CONFIGS);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.ACCESS_TOKEN, getData.access_token);
                    // sessionStorage.setItem(AUTHENTICATION.SHARED.SUPER_ADMIN, getData?.is_super_admin);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.SUPER_ADMIN, getData?.user_info?.is_superadmin);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.NORMAL_ADMIN, getData?.user_info?.is_admin);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.NAME, getData?.user_info?.name);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.USER_ID, getData?.user_info?.id);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.REFRESH_TOKEN, getData?.refresh_token);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.EMAIL, getData?.user_info.email);
                    sessionStorage.setItem(AUTHENTICATION.SHARED.ROLE, getData?.user_info?.role_id);
                    sessionStorage.setItem(AUTHENTICATION?.SHARED.PROFILE_HEADER, 'Dashboard')
                    navigate(ROUTES.DASHBOARD);
                    dispatch(headerBreadcam('Dashboard'))
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        } else {
            if (loginInfo.email === '') {
                kychandleChange("email", "");
            } else if (loginInfo.password === '') {
                kychandleChange("password", "");
            }
        }

    };

    //handle input changes 
    const kychandleChange = (name: any, value: any) => {
        var results = validateInput(name, value);
        if (results) {
            setError({ ...error, ...results.error });
            setErrorMsg({ ...errorMsg, ...results.errorMsg });
        }
        setLoginInfo({ ...loginInfo, [name]: value });
    };

    useEffect(() => {
        // Check if user info is saved in local storage
        const rememberedEmail = localStorage.getItem(AUTHENTICATION.SHARED.REMEMBERME_EMAIL);
        const rememberedPassword = localStorage.getItem(AUTHENTICATION.SHARED.REMEMBERME_PASDWORD);
        if (rememberedEmail && rememberedPassword) {
            setLoginInfo({
                email: rememberedEmail,
                password: rememberedPassword
            })
            setRememberMe(true);
        }
    }, []);

    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid container style={{ height: '100vh' }}>
                {/* Left side with background image */}
                <LeftSidContainer />

                {/* Right side with login form */}
                <Grid item xs={12} md={6} sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Container component="main" maxWidth="xs">
                        <CssBaseline />
                        <Box
                            sx={{
                                marginTop: 8,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                <img src={Logo} width={50} height={50} alt='logo' />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Login
                            </Typography>
                            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>

                                <TextField
                                    name='email'
                                    onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                    label='email'
                                    variant='outlined'
                                    helperText={errorMsg.email}
                                    value={loginInfo.email}
                                    error={error?.email}
                                    margin="normal"
                                    type='text'
                                    fullWidth
                                    inputProps={{ inputmode: 'email' }}
                                    InputProps={error.emailId && (errorMsg.email || loginInfo.email) === '' ? {} : {
                                        endAdornment: <CheckCircleOutlinedIcon />
                                    }}
                                />
                                <TextField
                                    name='password'
                                    onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                    label='password'
                                    variant='outlined'
                                    helperText={errorMsg.password}
                                    value={loginInfo.password}
                                    error={error?.password}
                                    margin="normal"
                                    type={Visibility}
                                    fullWidth
                                    inputProps={{ inputmode: 'password' }}
                                    InputProps={Visibility === 'password' ? {
                                        endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibility('text')}><VisibilityOffOutlinedIcon /></span>
                                    } : {
                                        endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibility('password')}><VisibilityOutlinedIcon /></span>
                                    }}
                                />
                                <FormControlLabel
                                    control={<Checkbox value="remember" checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)} color="primary" />}
                                    label="Remember me"
                                />
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                >
                                    Submit
                                </Button>
                                <Grid container>
                                    <Grid item xs>
                                        <Link href={ROUTES.FORGOTPASSWORD} variant="body2">
                                            Forgot password?
                                        </Link>
                                    </Grid>
                                    {/* <Grid item>
                                <Link href="#" variant="body2">
                                    {"Don't have an account? Sign Up"}
                                </Link>
                            </Grid> */}
                                </Grid>
                            </Box>
                        </Box>
                        {/* <Copyright sx={{ mt: 4, mb: 4 }} /> */}
                    </Container>
                </Grid>
            </Grid>

        </ThemeProvider>
    );
}